<template>
  <PlatformLayout :useOverlay="overlay">
    <v-card rounded max-width="1366" class="d-block mx-auto">
      <v-card-title>
        <v-container fluid class="d-flex flex-wrap justify-space-between pb-0">
          <h5 class="text-h5 font-weight-bold text-left">
            Productos&nbsp;<v-icon large>mdi-package-variant</v-icon>
          </h5>
          <v-btn @click="importar">
            <v-icon>mdi-file-excel-outline</v-icon>Importar Excel
          </v-btn>
        </v-container>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" md="12">
              <v-select
                v-model="selectedOption"
                :items="options"
                label="Familia"
                dense
                hide-details
              />
            </v-col>
          </v-row>
        </v-container>
        <Metalicos v-if="selectedOption == 'metalicos'" />
        <PanelTernium v-if="selectedOption == 'panel-ternium'" />
        <Isocindu v-if="selectedOption == 'panel-isocindu'" />
        <Otros v-if="selectedOption == 'otros'" />
      </v-card-text>
    </v-card>
  </PlatformLayout>
</template>

<script>
import PlatformLayout from "@/components/PlatformLayout.vue";
import Metalicos from "@/components/Productos/Metalicos/Metalicos";
import PanelTernium from "@/components/Productos/PanelTernium/PanelTernium";
import Isocindu from "@/components/Productos/Isocindu/Isocindu.vue";
import Otros from "@/components/Productos/Otros/Otros.vue";

export default {
  name: "Productos",
  components: {
    PlatformLayout,
    Metalicos,
    PanelTernium,
    Isocindu,
    Otros,
  },
  data() {
    return {
      overlay: false,
      options: [
        { text: "Metálicos", value: "metalicos" },
        { text: "Panel Ternium", value: "panel-ternium" },
        { text: "Panel Isocindu", value: "panel-isocindu" },
        { text: "Otros", value: "otros" },
      ],
      selectedOption: null,
    };
  },
  methods: {
    importar() {
      this.$router.push({
        path: "/platform/productos/importacion-" + this.selectedOption,
      });
    },
  },
  mounted() {
    this.selectedOption = this.options[0].value;
  },
};
</script>